const transliterationMap = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  ѓ: "gj",
  ђ: "dj",
  е: "e",
  ж: "zh",
  з: "z",
  ѕ: "dz",
  и: "i",
  ј: "j",
  ќ: "kj",
  к: "k",
  л: "l",
  љ: "lj",
  м: "m",
  н: "n",
  њ: "nj",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "c",
  ч: "ch",
  џ: "dj",
  ш: "sh",
};

export const cyrillicToLatin = (input = "") => {
  if (!input) return "";
  const lower = input.toLowerCase();
  return Array.from(lower)
    .map((char) => transliterationMap[char] || char)
    .join("");
};

export const cyrillicToLatinSlug = (input = "") => {
  const latin = cyrillicToLatin(input);
  if (!latin) return "";
  return latin
    .replace(/[^a-z0-9]+/gi, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "")
    .toLowerCase();
};
